import { getTokenHeader } from "@/helpers/commonHelper";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import axios from "axios";

export default {
  async getKisApiKeys({ commit, state }, query) {
    const headers = getTokenHeader();
    if (headers && state.selectedPrincipal?.id) {
      try {
        const response = await axios.get(`${env.kis_api_client_url}apikey/`, {
          params: {
            ...query,
            principal: state.selectedPrincipal.id
          },
          headers
        });
        commit("SET_KIS_API_KEYS", response?.data);
      } catch (e) {
        await this.dispatch("createError", e);
      }
    }
  },
  async getDepartments({ commit, state }, filter) {
    try {
      if (filter?.sort === "sortOrder") {
        delete filter.sort;
      }
      const headers = getTokenHeader();
      const response = await axios.get(`${env.kis_api_client_url}department/`, {
        params: {
          principal_id: state.selectedPrincipal.id,
          ...filter
        },
        headers
      });
      commit("SET_DEPARTMENT_COUNT", response.data?.count ?? 0);
      commit("SET_DEPARTMENT", response.data?.data ?? []);
    } catch (error) {
      await this.dispatch("createError", error);
      return false;
    }
  },
  async getPersons({ commit, state }, filter) {
    try {
      const headers = getTokenHeader();
      const safeFilter = { ...(filter ?? {}) };
      const getAll = Boolean(safeFilter.getAll);
      delete safeFilter.getAll;

      const requestParams = {
        principal_id: state.selectedPrincipal.id,
        ...safeFilter
      };

      if (!getAll) {
        const response = await axios.get(`${env.kis_api_client_url}person/`, {
          params: requestParams,
          headers
        });

        commit("SET_PERSONS", response.data?.data ?? []);
        commit("SET_PERSON_COUNT", response.data?.count ?? 0);
        return;
      }

      const pageSize =
        Number(safeFilter.limit) > 0 ? Number(safeFilter.limit) : 100;
      delete requestParams.page;
      delete requestParams.itemsPerPage;
      delete requestParams.skip;

      let persons = [];
      let totalCount = 0;
      let skip = 0;

      let hasMore = true;
      while (hasMore) {
        const response = await axios.get(`${env.kis_api_client_url}person/`, {
          params: {
            ...requestParams,
            skip,
            limit: pageSize
          },
          headers
        });

        const currentData = response.data?.data ?? [];
        totalCount = response.data?.count ?? totalCount;
        persons = persons.concat(currentData);

        hasMore = Boolean(currentData.length) && persons.length < totalCount;
        skip += currentData.length;
      }

      commit("SET_PERSONS", persons);
      commit("SET_PERSON_COUNT", totalCount);
    } catch (error) {
      await this.dispatch("createError", error);
      return false;
    }
  },
  async getCommittees({ commit, state }, filter) {
    try {
      const headers = getTokenHeader();
      const response = await axios.get(`${env.kis_api_client_url}committee/`, {
        params: {
          principal_id: state.selectedPrincipal.id,
          ...filter
        },
        headers
      });
      commit("SET_COMMITTEE_COUNT", response.data?.count ?? 0);
      commit("SET_COMMITTEES", response.data?.data ?? []);
    } catch (error) {
      await this.dispatch("createError", error);
      return false;
    }
  },
  async getSubjectAreas({ commit, state }, filter) {
    try {
      const headers = getTokenHeader();
      const response = await axios.get(
        `${env.kis_api_client_url}subjectarea/`,
        {
          params: {
            principal_id: state.selectedPrincipal.id,
            ...filter
          },
          headers
        }
      );
      commit("SET_SUBJECT_AREA_COUNT", response.data?.count ?? 0);
      commit("SET_SUBJECT_AREAS", response.data?.data ?? []);
    } catch (error) {
      await this.dispatch("createError", error);
      return false;
    }
  },
  async getTasks({ commit, state }, filter) {
    try {
      const headers = getTokenHeader();
      const getAll = filter?.getAll;
      delete filter?.getAll;
      const response = await axios.get(`${env.kis_api_client_url}task/`, {
        params: {
          principal_id: state.selectedPrincipal.id,
          ...filter
        },
        headers
      });

      const data = response.data?.data ?? [];
      if (getAll) {
        let tasks = state.tasks ?? [];
        tasks = tasks.concat(data);
        commit("SET_TASKS", tasks);
      } else {
        commit("SET_TASKS", data);
      }

      commit("SET_TASK_COUNT", response.data?.count ?? 0);
    } catch (error) {
      await this.dispatch("createError", error);
      return false;
    }
  },
  async getClubs({ commit, state }, filter) {
    try {
      const headers = getTokenHeader();
      const response = await axios.get(`${env.kis_api_client_url}club/`, {
        params: {
          principal_id: state.selectedPrincipal.id,
          ...filter
        },
        headers
      });
      commit("SET_CLUB_COUNT", response.data?.count ?? 0);
      commit("SET_CLUBS", response.data?.data ?? []);
    } catch (error) {
      await this.dispatch("createError", error);
      return false;
    }
  },
  async getFacilities(
    { commit, state },
    filter = { sort: "sortOrder", direction: "asc" }
  ) {
    try {
      const headers = getTokenHeader();
      if (!filter.sort) filter.sort = "sortOrder";
      if (!filter.direction) filter.direction = "asc";
      const response = await axios.get(`${env.kis_api_client_url}facility/`, {
        params: {
          principal_id: state.selectedPrincipal.id,
          ...filter
        },
        headers
      });
      commit("SET_FACILITY_COUNT", response.data?.count ?? 0);
      commit("SET_FACILITIES", response.data?.data ?? []);
    } catch (error) {
      await this.dispatch("createError", error);
      return false;
    }
  },
  async getDefects({ commit, state }, filter) {
    try {
      const headers = getTokenHeader();
      const response = await axios.get(`${env.kis_api_client_url}defect/`, {
        params: { principal_id: state.selectedPrincipal.id, ...filter },
        headers
      });
      commit("SET_DEFECT_COUNT", response.data?.count ?? 0);
      commit("SET_DEFECTS", response.data?.data ?? []);
    } catch (e) {
      await this.dispatch("createError", e);
      return false;
    }
  },
  async getDefectStatistics({ commit, state }, filter = {}) {
    try {
      const headers = getTokenHeader();
      const response = await axios.get(
        `${env.kis_api_client_url}defect/statistics`,
        {
          params: { principal_id: state.selectedPrincipal.id, ...filter },
          headers
        }
      );
      commit("SET_DEFECT_STATISTICS", response?.data ?? {});
    } catch (e) {
      await this.dispatch("createError", e);
      return false;
    }
  },
  async getDefectCategories({ commit, state }, filter) {
    try {
      const headers = getTokenHeader();
      const response = await axios.get(
        `${env.kis_api_client_url}defectCategory/`,
        {
          params: { principal_id: state.selectedPrincipal.id, ...filter },
          headers
        }
      );
      commit("SET_DEFECT_CATEGORIES", response.data ?? []);
    } catch (e) {
      await this.dispatch("createError", e);
      return false;
    }
  },
  async getRelatedTasks({ commit, state }, idArray) {
    const params = {
      principal_id: state.selectedPrincipal.id
    };
    const tasksArray = [];
    idArray.asyncForEach(async id => {
      const headers = getTokenHeader();
      const result = await axios.get(`${env.kis_api_client_url}task/${id}`, {
        params,
        headers
      });
      tasksArray.push(result.data);
    });
    commit("SET_RELATED_TASKS", tasksArray);
  },
  async resetRelatedTasks({ commit }) {
    commit("SET_RELATED_TASKS", []);
  },
  async getAutocompleteTasks({ commit }, params) {
    let tasks = [];
    const headers = getTokenHeader();
    const result = await axios.get(`${env.kis_api_client_url}task/`, {
      params,
      headers
    });
    tasks = result.data?.data ?? [];
    commit("SET_AUTOCOMPLETE_TASKS", tasks);
  }
};
